var app = angular.module("leonardo");

var AccountUserReportToDialog = function($scope, $rootScope, FormErrorsService, AccountUserService) {
  $scope.accountUser = $scope.ngDialogData.accountUser;
  $scope.accountUserService = AccountUserService;

  $scope.getUsersReportTo = function (params) {
    return AccountUserService.getUsersReportTo($scope.accountUser.id, params);
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.accountUser.deleteReportTo({report_to: $scope.user}).then(function() {
      $rootScope.$broadcast('account-user:deleted');
      $scope.closeThisDialog();
    });
  };
};

app.controller('AccountUserReportToDialog', ['$scope', '$rootScope', 'FormErrorsService', 'AccountUserService',
  AccountUserReportToDialog]);
